import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@/components/theme-provider';
import { AppLayout } from '@/components/layouts/AppLayout';
import { Dashboard } from '@/features/dashboard/pages/Dashboard';
import { VenuesPage } from '@/features/venues/pages/VenuesPage';
import { OffersPage } from '@/features/offers/pages/OffersPage';
import { AnalyticsPage } from '@/features/analytics/pages/AnalyticsPage';
import { UsersPage } from '@/features/admin-users/pages/AdminUsersPage';
import { SettingsPage } from '@/features/settings/pages/SettingsPage';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { PromoOffersPage } from '@/features/promo-offers/pages/PromoOffersPage';
import { OrganizationsPage } from './features/organizations/pages/OrganizationsPage';
import { LoginPage } from '@/features/auth/components/LoginPage';

function App() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="urban-finch-theme">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<AppLayout />}>
          <Route index element={<Dashboard />} />
          <Route
            path="venues/*"
            element={
              <ProtectedRoute permission="venue_management:read">
                <VenuesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="offers/*"
            element={
              <ProtectedRoute permission="offer_management:read">
                <OffersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="promo-offers/*"
            element={
              <ProtectedRoute permission="offer_management:read">
                <PromoOffersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="analytics"
            element={
              <ProtectedRoute permission="system_management:read">
                <AnalyticsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin-users/*"
            element={
              <ProtectedRoute permission="system_management:read">
                <UsersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="organizations/*"
            element={
              <ProtectedRoute permission="system_management:read">
                <OrganizationsPage />
              </ProtectedRoute>
            }
          />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
      </Routes>
    </ThemeProvider>
  );
}

export default App;
